
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AppSubmenuComponent } from './submenu/app-submenu.component';
import { DistrictSitesComponent } from './district-sites/district-sites.component';
import { MatCardModule } from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import { SafeHtmlPipe } from 'src/app/core/shared/safeHtml.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    AppSubmenuComponent,
    DistrictSitesComponent,
    SafeHtmlPipe
  ],
  imports: [
    MatIconModule,
    MatCardModule,
    CommonModule,
    MatIconModule,
    MatMenuModule,
    FontAwesomeModule,
    FormsModule,
    MatExpansionModule,
    QuillModule.forRoot()
  ],
  exports: [AppSubmenuComponent, DistrictSitesComponent]
})
export class LandingPageModule { }
